export enum ProductContentTypeEnum {
    html = 'html',
    multimedia = 'multimedia',
    text = 'text'
}

export default interface ProductDescriptionInterface {
    text: string;
    multimedia: string;
    html: string;
    content: {
        text: string | null;
        type: ProductContentTypeEnum | null;
    };
}
